import { render } from "./ban-icon.svg?vue&type=template&id=ba11332e"
import script from "./ban-icon.svg?vue&type=script&lang=js"
export * from "./ban-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1567/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__